export default __webpack_public_path__ + "static/2019 StM Annual School Report-086685184f26367422c36d0805d1c0a5.pdf";